import Contact from './container/ContactContainer';

export default Contact;
